<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: #ffffff;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainer" id="videoContainer" class="pa-0 ma-0 hidden-xs" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <Transition name="fade" mode="out-in">
            <div v-show="isImageLoading" class="loading-spinner"
              :style="{ height: videoHeight + 'px', width: '100vw', position: 'fixed', top: 0, left: 0, display: 'flex', background: '#ffffff' }">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
            </div>
          </Transition>
          <Transition name="fade" mode="out-in">
            <v-img v-show="!isImageLoading" :src="require('@/assets/images/home.webp')" cover
              :style="{ height: videoHeight + 'px', top: 0, left: 0, width: '100vw', opacity: 0.8 }">
              <img @load="handleImageCanPlay" :src="require('@/assets/images/home.webp')" style="display: none;" />
            </v-img>
          </Transition>
          <Transition name="fade" mode="out-in">
            <div v-show="!isImageLoading" id="bkgrdVideoFunc" :style="{ height: videoHeight + 'px' }">
              <v-row class="textVideo pb-16 mb-16">
                <div class="container">
                  <v-row justify="start" class="pl-8 pr-8 videoMargins fonts">
                    <h1 class="font2-heada" style="color: black;">BUILT TO LAST FOR GENERATIONS
                    </h1>
                  </v-row>
                  <v-row justify="start" class="pl-8 pr-8 pt-2 videoMargins">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border1"
                      @click="handleClickVideo('FamilyOffice')">
                      Family Office Services
                    </v-btn>
                  </v-row>
                </div>
              </v-row>
            </div>
          </Transition>
        </div>
      </div>
      <div ref="videoContainer2" id="videoContainer2" class="pa-0 ma-0 hidden-sm-and-up"
        :style="{ height: videoHeight2 + 'px' }">
        <div id="videoContent2" class="pa-0 ma-0" :style="{ height: videoHeight2 + 'px' }">
          <Transition name="fade" mode="out-in">
            <div v-show="isImageLoading" class="loading-spinner"
              :style="{ height: videoHeight2 + 'px', width: '100vw', position: 'fixed', top: 0, left: 0, display: 'flex', background: '#ffffff' }">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
            </div>
          </Transition>
          <Transition name="fade" mode="out-in">
            <v-img v-show="!isImageLoading" :src="require('@/assets/images/home.webp')" cover
              :style="{ height: videoHeight2 + 'px', top: 0, left: 0, width: '100vw',  opacity: 0.8 }">
              <img @load="handleImageCanPlay" :src="require('@/assets/images/home.webp')" style="display: none;" />
            </v-img>
          </Transition>
          <Transition name="fade" mode="out-in">
            <div v-show="!isImageLoading" id="bkgrdVideoFunc2" :style="{ height: videoHeight2 + 'px' }">
              <v-row class="textVideo pb-16 mb-16">
                <div class="container">
                  <v-row justify="center" class="pl-8 pr-8 videoMargins fonts">
                    <h1 class="font2-heada" style="color: black;">BUILT TO LAST FOR GENERATIONS
                    </h1>
                  </v-row>
                  <v-row justify="center" class="pl-8 pr-8 pt-2 videoMargins">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border1"
                      @click="handleClickVideo('FamilyOffice')">
                      Family Office Services
                    </v-btn>
                  </v-row>
                </div>
              </v-row>
            </div>
          </Transition>
        </div>
      </div>

      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">QUANTITATIVE TRADING</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          Quantitative trading leverages advanced AI to analyze vast financial datasets, uncover patterns, and execute trades. It's a game-changer for investors and funds seeking data-driven strategies and enhanced market insights.
                        </span>
                      </v-row>                
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickVideo('Quant')">
                        Read more
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">QUANTITATIVE TRADING</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Quantitative trading leverages advanced AI to analyze vast financial datasets, uncover patterns, and execute trades. It's a game-changer for investors and funds seeking data-driven strategies and enhanced market insights.
                        </span>
                      </v-row>  
                  <v-row justify="start" class="pl-9 pr-9 hidden-sm-and-up pt-0 mt-0">
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickVideo('Quant')">
                        Read more
                      </v-btn>
                  </v-row>
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="full-container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-down">
                    <v-col cols="6" class="pa-0 ma-0 pr-4">                  
                      <h1 class="font3-heada" style="color:black!important;">"AI that leaves emotions behind, focusing solely on executing strategies driven by data. Its strength lies in objective analysis, enabling decisions free from human bias and intuition."</h1>
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall" style="color:black!important;">
                          T. Andel
                        </span>
                        <v-row>
                          <span class="mt-0 pb-0 mb-0 pl-3 pt-1 fonts-xsmall2" style="color:black!important;">
                            Quant at 42Monks Capital
                          </span>
                        </v-row>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-8">
                        <v-img style="opacity: 0.9" :src="require('@/assets/images/pollock2.webp')"></v-img>
                      </v-row> 
                        <div style="text-align: center; width: 100%; padding-top: 8px;">
                          <span class="fonts-xsmall2" style="color:black!important;">
                            Number 14 (Gray), 1948 by Jackson Pollock
                          </span>
                        </div>               
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-0 pb-2 hidden-md-and-up pt-0 mt-0">
                        <v-img style="opacity: 0.9" :src="require('@/assets/images/pollock2.webp')"></v-img>
                  </v-row> 
                   <v-row justify="center" class="pl-12 pr-12 pt-0 pb-4 hidden-md-and-up pt-0 mt-0">
                        <div style="text-align: center; width: 100%; padding-top: 8px;">
                          <span class="fonts-xsmall2" style="color:black!important;">
                            Number 14 (Gray), 1948 by Jackson Pollock
                          </span>
                        </div>  
                  </v-row>  
                  <v-row justify="start" class="pl-12 pr-12 hidden-md-and-up pt-8 mt-0">
                        <h1 class="font3-heada" style="color:black!important;">"AI that leaves emotions behind, focusing solely on executing strategies driven by data. Its strength lies in objective analysis, enabling decisions free from human bias and intuition."</h1>
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall" style="color:black!important;">
                          T. Andel
                        </span>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-md-and-up pt-2 mt-0">
                        <span class="mt-0 pb-0 mb-0 fonts-xsmall2" style="color:black!important;">
                          Quant at 42Monks Capital
                        </span>
                  </v-row>
                </div>
            </v-row>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">

            <v-row class="textPanel pb-2">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                    <v-col cols="12" class="pa-0 ma-0 pl-9 pr-9">                  
                      <h1 class="font2-heada" style="color:black!important;">WEALTH MANAGEMENT</h1>
                    </v-col>
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="12" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-8">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          Generational Wealth Management is about preserving and growing assets so families can thrive for decades. Our services help ensure your legacy endures, providing stability, security, and opportunities for future generations.
                          <br/><br/>We offer services to HNWI, individuals, and families including fund investment managers. 
                          We also provide expertise in Private Wealth Management services (Monaco office) along with our partners to help you grow and protect your wealth across generations.
                          
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-6 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Generational Wealth Management is about preserving and growing assets so families can thrive for decades. Our services help ensure your legacy endures, providing stability, security, and opportunities for future generations.
                                                    <br/><br/>We offer services to HNWI, individuals, and families including fund investment managers. 
                          We also provide expertise in Private Wealth Management services (Monaco office) along with our partners to help you grow and protect your wealth across generations.
                          </span> 
                  </v-row>  
                </div>
            </v-row>
      </div>
          <v-row class="textPanel page-top pb-0 pt-4">
                <div class="full-container">
                  <v-img  style="opacity: 0.9" :src="require('@/assets/images/hp_2.webp')"></v-img>
                </div>
          </v-row>


      <div class="body-overall fonts">
        <v-row class="textPanel pb-0">
          <v-divider class="divider ml-9 mr-9 hidden-xs mt-14" style="color: black!important;"></v-divider>
          <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up mt-14" style="color: black!important;"></v-divider>
        </v-row>
      </div>
      <div class="body-overall fonts">
        <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>

import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'HomePage',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    videoHeight: 1000, // Initial height of the video
    videoHeight2: 700,
    isDesktop: false,
    isVideoLoading: true,
    isImageLoading: true,
  }),
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },
  created() {

  },
  methods: {
    handleVideoCanPlay() {
      this.isVideoLoading = false;
    },
    handleImageCanPlay() {
      this.isImageLoading = false;
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768; // Ustaw szerokość graniczną na 768 pikseli (możesz dostosować według potrzeb)
    },
    handleScroll() {
      if (!this.drawerham) {
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;

        const newVideoHeight2 = Math.round(Math.max(500, 700 - scrollPosition));
        this.videoHeight2 = newVideoHeight2;
      }
    },
    handleClickVideo(link) {
      if (link) {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';
@use './css/styles_finance.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append) {
  display: inline-block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease !important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}

#videoContainer {
  position: relative;
  box-sizing: border-box;
  max-height: 1000px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 1000px;
  transition: height 0.10s linear;
}

#videoContainer2 {
  position: relative;
  box-sizing: border-box;
  max-height: 700px;
  transition: height 0.10s linear;
}

#videoContent2 {
  position: sticky;
  top: 0;
  max-height: 700px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 1000px;
  object-fit: cover;
  background-color: #00000000;
  z-index: 5;
  transition: height 0.10s linear;
}

#bkgrdVideoFunc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 1000px;
  object-fit: cover;
  background-color: #00000000;
  z-index: 6;
  transition: height 0.10s linear;
}

#bkgrdVideoFunc2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 700px;
  object-fit: cover;
  background-color: #00000000;
  z-index: 6;
  transition: height 0.10s linear;
}

#bkgrdVideo {
  width: 100%;
  max-height: 1000px;
  object-fit: cover;
  z-index: 1;
  transition: height 0.10s linear;
}

.overall {
  background-color: #ffffff !important;
  object-fit: cover;
  height: 100%;
  display: block;
}

.body-overall {
  background-color: #ffffff !important;
  margin: 0;
  /* Remove default margin */
  padding: 0;
  /* Remove default padding */
  z-index: 3;
}

.full-container {
  background-color: #ffffff !important;
  width: 100% !important;
  max-width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;

  @media (min-width: 600px) {
    width: 100% !important;
  }

  @media (min-width: 1280px) {
    width: 1625px !important;
  }
}

.nomenu-btn-page {
  color: black !important;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black !important;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%;
  /* Spread the line over the text and icon */
  height: 1px;
  /* Line thickness */
  background-color: black;
  /* Color of the underline */
  opacity: 1;
  /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3;
  /* Show the underline when hovering */
}

.nomenu-btn-link {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%;
  /* Spread the line over the text and icon */
  height: 1px;
  /* Line thickness */
  background-color: black;
  /* Color of the underline */
  opacity: 0;
  /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1;
  /* Show the underline when hovering */
}

.loading-spinner {
  justify-content: center;
  align-items: center
}
</style>
